import { render } from "./CameraComponent.vue?vue&type=template&id=50f32eac&scoped=true"
import script from "./CameraComponent.vue?vue&type=script&lang=js"
export * from "./CameraComponent.vue?vue&type=script&lang=js"

import "./CameraComponent.vue?vue&type=style&index=0&id=50f32eac&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f32eac"]])

export default __exports__